import React, { useEffect, useState } from "react";
import {
  Badge,
  Table,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Typography,
  Radio,
  Checkbox,
  InputNumber,
  Modal,
  Button,
  Form,
  Spin,
  message,
  Skeleton,
} from "antd";
import { Icon } from "@iconify/react";
import { mdiPlusCircle, mdiCheckCircleOutline } from "@mdi/js";
import Input from "../../components/textfield/input";
import "../../assets/styles/admin/quotation.scss";
import SearchField from "../../components/textfield/searchField";
import TableColumn from "../../components/table/tableColumn";
import MainTable from "../../components/table/mainTable";
import CheckboxText from "../../components/textfield/checkbox";
import HeaderBar from "../../components/header/headerBar";
import MainButton from "../../components/button/mainButton";
import Counter from "../../components/counter/counter";
import SelectField from "../../components/select/selectField";
import SearchFieldSelect from "../../components/textfield/searchFieldSelect";
import axios from "axios";
import moment from "moment";
import { numberWithCommas } from "../../helpers/functions";
import styled from 'styled-components'
interface Props {
  Item?: any;
  ChangItem: (item: any) => void;
  ChangStep: (number: number) => void;
  ChangOther: (text: string) => void;
  ChangUserData?: (text: object | any) => void;
  userData?: object | any;
}
const QuotationCreateStep1: React.FC<Props> = ({
  ChangItem,
  ChangStep,
  ChangOther,
  ChangUserData,
  userData,
  Item = [],
}) => {
  const onSubmit = () => { };

  // set Data to APIs
  const ChangRender = styled.div``
  const [subTitle, setSubTitle] = useState<string>("");
  const [channel, setChannel] = useState("");
  const [date, setDate] = useState("");
  const [sale, setSale] = useState("");
  const [other, setOther] = useState<string>(userData?.purchaseType);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [isOpenItem, setIsOpenItem] = useState<any>({});
  const [searchKeyItem, setSearchKeyItem] = useState<string>("");
  const [searchKeyOption, setSearchKeyOption] = useState<string>("name");
  const [saleList, setSaleList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectAesthetic, setSelectAesthetic] = useState<any>(Item);
  const [countSelectAesthetic, setCountSelectAesthetic] = useState<number>(
    Item.length
  );
  const [productList, setProductList] = useState<any>([]);
  const columns = [
    {
      title: "รหัส/Code",
      key: "Code",
      align: "center" as "center",
      dataIndex: "code",

      render: (text: any, record: any, index: any) => {
        return (
          <Row justify="start">
            <Space>
              <Icon
                onClick={() => {
                  handleSelectConfirm(record);
                }}
                icon="akar-icons:circle-plus-fill"
                color="#4d7e7f"
                width="24"
                height="24"
              />
              {text}
            </Space>
          </Row>
        );
      },
    },
    {
      key: "name",
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as "center",
      width: "350px",
    },
    {
      key: "price",
      title: "ราคา/Price",
      dataIndex: "price",
      align: "center" as "center",

      render: (text: any, record: any) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      key: "quantity",
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as "center",
      width: "180px",
      render: (text: any, record: any, index: number) => (
        <Counter
          fixed={false}
          defaultValue={record.quantity}
          length={1}
          changeValue={(value) => (record.quantity = value)}
        />
      ),
    },
    {
      key: "Commission",
      title: "คอมมิชชั่น/Commission",
      dataIndex: "Commission",
      align: "center" as "center",
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "Sales",
          key: "Sales",
          align: "center" as "center",
          width: "10%",
          render: (text: any, record: any, index: number) => {
            return (
              <CheckboxText
                className="col"
                id="0"
                title="ได้"
                isChecked={record?.commission?.sales}
                onChange={(e) => {
                  record.commission.sales = e.target.checked;
                  setProductList([...productList])
                }}
              />
            );
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "Doctor",
          key: "Doctor",
          align: "center" as "center",

          render: (text: any, record: any, index: number) => {
            return (

              <CheckboxText
                className="col"
                id="1"
                title="ได้"
                isChecked={record?.commission?.doctor}
                onChange={(e) => {
                  record.commission.doctor = e.target.checked;
                  setProductList([...productList])
                }}
              />
            );
          },
        },
      ],
      colspan: 2,
    },
    {
      key: "Description",
      title: "คำอธิบาย/Description",
      dataIndex: "detail",
      align: "center" as "center",
    },
  ];
  const columns2 = [
    {
      title: "รหัส/Code",
      align: "center" as "center",
      dataIndex: "code",
      width: "18%",
      render: (text: any, record: any, index: any) => {
        return (
          <Row justify="start">
            <Space>
              <Icon
                onClick={() => {
                  handleSelectConfirm(record)
                }}
                icon="akar-icons:circle-plus-fill"
                color="#4d7e7f"
                width="24"
                height="24"
              />
              {`${text}`}
            </Space>
          </Row>
        );
      },
    },
    {
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as "center",
    },
    {
      title: "ราคาโปรโมชั่น/Pro Price",
      dataIndex: "price",
      align: "center" as "center",
      width: "10%",
    },
    {
      title: "วันที่เริ่ม-วันที่หมดอายุ/Start Date Exp Date",
      dataIndex: "startenddate",
      align: "center" as "center",
      width: "13%",
      render: (text: any, record: any, index: number) => {
        return (
          <>
            {moment(record.startDate).format("DD-MM-YYYY")} <br />{" "}
            {moment(record.endDate).format("DD-MM-YYYY")}
          </>
        )
      }
    },
    {
      title: "คอมมิชชั่น/Commission",
      children: [
        {
          title: "พนักงานขาย/Sales",
          align: "center" as "center",
          width: "1%",
          render: (text: any, record: any, index: number) => {
            return (
              <CheckboxText
                className="col"
                id="0"
                title="ได้"
                isChecked={record?.commission?.sales}
                onChange={(e) => {
                  record.commission.sales = e.target.checked;
                  setProductList([...productList])
                }}
              />
            );
          },
        },
        {
          title: "แพทย์/Doctor",
          align: "center" as "center",
          width: "1%",
          render: (text: any, record: any, index: number) => {
            return (
              <CheckboxText
                className="col"
                id="1"
                title="ได้"
                isChecked={record?.commission?.doctor}
                onChange={(e) => {
                  record.commission.doctor = e.target.checked;
                  setProductList([...productList])
                }}
              />
            );
          },
        },
      ],
    },
  ];
  const [priceTypeList, setPriceTypeList] = useState<boolean | any>([]);


  const option = [
    { value: "name", name: "Search By Name" },
    { value: "code", name: "Search By Code" },
  ];

  const getData = () => {
    setChannel("-");
    setDate("2564-12-07");
    setSale("2");
  };

  const type = [
    { value: "normal", name: "Normal" },
    { value: "promotion", name: "Promotion" },
  ];

  const onChangeOtherd = (index: string) => {
    setSearchKeyOption(index);
    console.log("index xxx => ", index);
  };

  useEffect(() => {
    getData();
    getCategory();
  }, []);

  useEffect(() => {
    axios.get(`/users/sale`).then((res) => {
      setSaleList(res.data?.data);
    });
    chengOther(userData?.purchaseType);
  }, []);
  const handleInputChange = (event: any) => {
    let index = userData.categories.findIndex((item: any) => item?.code === event.code);
    console.log(index)
    if (index > -1) {
      let categories = userData.categories;
      categories.splice(index, 1);
      ChangUserData?.({
        ...userData,
        categories,
      });
    } else {
      let categories = userData.categories;
      categories.push({
        _id: event._id,
        code: event.code,
        name: event.name,
      })
      ChangUserData?.({
        ...userData,
        categories,
      });
    }
  };
  const handleSelectAesthetic = (item: any) => {
    let dataChange = selectAesthetic;
    dataChange.push(item);
    setSelectAesthetic(dataChange);
    setCountSelectAesthetic(dataChange.length);
    ChangItem(dataChange);
  };
  const handleSelectConfirm = (item: any) => {
    setIsOpenConfirm(true);
    setIsOpenItem(item);
    // handleSelectAesthetic(item)
  };
  const resetSelectAesthetic = () => {
    ChangItem([]);
    setSelectAesthetic([]);
    setCountSelectAesthetic(0);
  };

  const chengOther = (select: string) => {
    setOther(select);
    setProductList([]);
    ChangOther(select);
    ChangUserData?.({
      ...userData,
      purchaseType: select,
    });
    // resetSelectAesthetic();
    switch (select) {
      case "normal":
        setSubTitle("รายการสินค้าและบริการ/Product And Service List");
        axios.get(`/treatments?page=1`).then((res) => {
          setProductList(
            res.data?.data.map((item: any) => {
              return {
                ...item,
                quantity: 1,
                price: item?.price?.normal?.coursePriceLocal,
                discount: 0,
                commission: {
                  sales: false,
                  doctor: false,
                },
                remark: "",
              };
            })
          );
        });
        break;
      case "promotion":
        setSubTitle("Promotional Items");
        axios.get(`/promotions?page=1`).then((res) => {
          setProductList(
            res.data?.data.map((item: any) => {
              return {
                ...item,
                quantity: 1,
                name: item.promotionName,
                price: item.promotionPrice,
                discount: 0,
                commission: {
                  sales: false,
                  doctor: false,
                },
                remark: "",
              };
            })
          );
        });
        break;
      default:
        setSubTitle("รายการสินค้าและบริการ/Product And Service List");
        break;
    }
  };

  const getCategory = async () => {
    axios.get(`/product-categories?page=1`).then((res) => {
      const category = res?.data?.data;
      setCategories(category);
    });
  };

  const TableCourse = () => {
    return (
      <>
        <Table
          columns={columns}
          dataSource={searchItem()}
          bordered
          scroll={{ x: "max-content" }}
          rowKey="_id"
        />
      </>
    );
  };
  const TablePromotion = () => {
    return (
      <>
        <Table
          columns={columns2}
          dataSource={searchItem()}
          bordered
          scroll={{ x: "max-content" }}
          rowKey="_id"
        />
      </>
    );
  };
  const checkUserData = () => {
    if (userData.sale === "" || userData.sale === null)
      ChangUserData?.({ ...userData, sale: JSON.stringify(saleList[0]) });
    ChangStep(2);
  };

  useEffect(() => {
    const mediaCheng = window.matchMedia('(max-width : 400px)');
    mediaCheng.addEventListener('change', (event: MediaQueryListEvent) => matchesEvent(event))
    matchesEvent(mediaCheng);
  }, []);
  const matchesEvent = (event: any) => {
    if (event.matches) {
      document.querySelectorAll(".isWindow").forEach((el: any) => {
        el.style.display = 'none';
      })
      document.querySelectorAll(".isMoblie").forEach((el: any) => {
        el.style.display = 'block';
      })
    } else {
      document.querySelectorAll(".isWindow").forEach((el: any) => {
        el.style.display = 'block';
      })
      document.querySelectorAll(".isMoblie").forEach((el: any) => {
        el.style.display = 'none';
      })
    }
  }
  const searchItem = () => {
    if (searchKeyItem.length >= 1) {
      let calculateData: any = [];
      for (let i = 0; i < productList.length; i++) {
        if (productList[i][searchKeyOption]?.substr(0, searchKeyItem).toUpperCase() === searchKeyItem.toUpperCase()) {
          calculateData.push(productList[i]);
        } else if (productList[i][searchKeyOption]?.toUpperCase().indexOf(searchKeyItem.toUpperCase()) > -1) {
          calculateData.push(productList[i]);
        }
      }
      return calculateData;
    } else {
      return productList;
    }
  };

  return (
    <div>
      <HeaderBar title="QUOTATION" btnBack={true}>
        <Badge count={countSelectAesthetic} overflowCount={10}>
          <MainButton
            className="isWindow"
            title="รายการที่เลือก/Selected Item"
            onClick={() => checkUserData()}
          />
        </Badge>
      </HeaderBar>
      <div style={{ padding: "30px 30px" }}>
        <Modal
          visible={isOpenConfirm}
          footer={false}
          onCancel={() => setIsOpenConfirm(false)}
          centered
        >
          <>
            {/* {console.log("record", record)} */}
            <Row justify="center">
              <Icon
                icon="ei:check"
                color="#5BAEA9"
                width="20%"
                height="20%"
                style={{ marginBottom: "28px" }}
              />
            </Row>
            {/* {console.log("textmodal", textModal)} */}
            <Row justify="center">
              <Col>
                <h6>
                  ทำการสั่งซื้อ {isOpenItem.name} {isOpenItem?.quantity}{" "}
                  {isOpenItem?.treatmentUnit !== null
                    ? isOpenItem?.treatmentUnit
                    : ""}
                </h6>
              </Col>
            </Row>
            <Row justify="center">
              <Col>
                <h6>
                  Make Order {isOpenItem.name} {isOpenItem?.quantity}{" "}
                  {isOpenItem?.treatmentUnit !== null
                    ? isOpenItem?.treatmentUnit
                    : ""}
                </h6>
              </Col>
            </Row>
            <Row className="Button-Select">
              <Space>
                <Col className="Cancle-Button">
                  <Button onClick={() => setIsOpenConfirm(false)}>
                    ยกเลิก/Cancel
                  </Button>
                </Col>
                <Col className="Continue-Button">
                  <Button
                    onClick={() => {
                      handleSelectAesthetic(isOpenItem);
                      setIsOpenConfirm(false);
                    }}
                  >
                    เลือกซื้อต่อ/Continue
                  </Button>
                </Col>
                <Col className="Select-Button">
                  <Button
                    onClick={() => {
                      handleSelectAesthetic(isOpenItem);
                      setIsOpenConfirm(false);
                      setTimeout(() => {
                        checkUserData();
                      }, 500);
                    }}
                  >
                    รายการซื้อ/Select Item
                  </Button>
                </Col>
              </Space>
            </Row>
          </>
        </Modal>
        <div className="row">
          <div className="col-12 mb-2" style={{
            display: 'grid',
            justifyContent: 'end'
          }}>
            <MainButton
              className="isMoblie"
              title="รายการที่เลือก/Selected Item"
              onClick={() => checkUserData()}
            />
          </div>
        </div>
        <form onSubmit={onSubmit}>
          <div className="create-page">
            <div className="row space-between">

              <div className="col-12 col-sm-4">
                <Input
                  title="ลูกค้า/Customer"
                  value={userData.customer}
                  onChange={(e) => {
                    ChangUserData?.({
                      ...userData,
                      customer: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-12 col-sm-4">
                <div className="select-field col-12">
                  <div className="title-input">ผู้ขาย/Sale</div>
                  <select
                    name="cars"
                    id="cars"
                    placeholder=""
                    value={userData.sale}
                    onChange={(e) => {
                      ChangUserData?.({
                        ...userData,
                        sale: e.target.value,
                      });
                    }}
                  >
                    {saleList.map((option: any, index) => (
                      <option value={JSON.stringify(option)} key={index}>
                        {option.displayName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-12 col-sm-4">
                <ChangRender>
                  <div className="heading">
                    <p>วันที่/Date</p>
                  </div>
                  <Form.Item
                    name="startDate"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="mm/dd/yyyy"
                      format="DD-MM-YYYY"
                      style={{
                        height: "auto",
                        width: "100%",
                        border: "none",
                        borderRadius: "0px",
                        borderBottom: "2px solid #d9d9d9",
                      }}
                      onChange={(e: any) => {
                        ChangUserData?.({
                          ...userData,
                          date: e.format(),
                        });
                      }}
                      defaultValue={moment(userData.date) || moment()}
                    />
                  </Form.Item>
                </ChangRender>
              </div>
            </div>
            <div className="row space-between"></div>
          </div>
          <div className="create-page mt-40">
            <div className="row ">
              <SelectField
                className="col-12 col-sm-4"
                title="ประเภทการซื้อ/Purchase Type"
                option={type}
                onChange={(value) => chengOther(value.target.value)}
                value={userData.purchaseType}
              />
              {userData?.purchaseType !== "promotion" && (
                <div className="row col-12 col-sm-6">
                  {
                    categories.map((item: any, index: number) => (
                      <CheckboxText
                        key={index}
                        onChange={(event) => handleInputChange(item)}
                        name="categories"
                        className="col"
                        title={item.code}
                        isChecked={userData.categories.findIndex((i: any) => i?.code === item.code) > -1 ? true : false}
                      />
                    ))
                  }
                </div>
              )}
            </div>
          </div>
          <div style={{ marginTop: "50px" }}>
            <div className="title-header">
              <h3 style={{ textTransform: "uppercase", color: "black" }}>
                {subTitle}
              </h3>
            </div>
            <SearchFieldSelect
              placeholder="Search (Name, Code)"
              color="#FFFFFF"
              option={option}
              onChange={(e: any) => setSearchKeyItem(e.target.value)}
              onChangeOtherd={onChangeOtherd}
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            {userData?.purchaseType === "normal" ? <TableCourse /> : <TablePromotion />}
          </div>
        </form>
      </div>
    </div>
  );
};
export default QuotationCreateStep1;
